import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getTicketsList as getTicketsListApi,
  addNewTicket as addNewTicketApi,
  updateTicket as updateTicketApi,
  deleteTicket as deleteTicketApi,
} from '../../helpers/fakebackend_helper';

export const getTicketsList = createAsyncThunk(
  'tickets/getTicketsList',
  async () => {
    try {
      const response = getTicketsListApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewTicket = createAsyncThunk(
  'tickets/addNewTicket',
  async ticket => {
    try {
      const response = addNewTicketApi(ticket);
      const data = await response;
      notify.success('Ticket added successfully.');
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const updateTicket = createAsyncThunk(
  'tickets/updateTicket',
  async ticket => {
    try {
      const response = updateTicketApi(ticket);
      const data = await response;
      notify.success('Ticket updated successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'update ticket');
      return error;
    }
  }
);

export const deleteTicket = createAsyncThunk(
  'tickets/deleteTicket',
  async ticket => {
    try {
      const response = deleteTicketApi(ticket);
      notify.success('Ticket deleted successfully.');
      return { ticket, ...response };
    } catch (error) {
      notify.apiError(error, 'delete ticket');
      return error;
    }
  }
);
